import { useEffect } from "react";

/** Fire `handler` when a key is pressed anywhere in the document. */
export function useKeyDown(key, handler) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === key) handler(event);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [key, handler]);
}

export default useKeyDown;
